<template >
  <div class="staff-course-form">
    <el-dialog :visible.sync="visible" :title="$t('Staff.attend')" left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="100px">
            <el-form-item
                v-if="staffLesson.canTeamLesson"
                prop="teamLessonIds"
                :label="$t('Staff.take_team')" >
                <el-checkbox
                    :indeterminate="teamIndeterminate"
                    v-model="checkAllTeamLesson"
                    @change="handleCheckAllTeamLesson"
                >{{ $t('Course.check_all') }}</el-checkbox>
                <div class="box-a">
                    <el-checkbox-group
                        v-model="form.teamLessonIds"
                        @change="handleCheckTeamLesson">
                        <el-checkbox
                            style="width:100%; margin: 0px 5px"
                            v-for="item in teamLessons"
                            :label="item.id"
                            :key="item.id"
                        >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form-item>
            <el-form-item
                :label="$t('Staff.take_personal')"
                v-if="staffLesson.canCoachLesson">
                <el-checkbox
                    :indeterminate="coachIndeterminate"
                    v-model="checkAllCoachLesson"
                    @change="handleCheckAllCoachLesson"
                >{{ $t('Course.check_all') }}</el-checkbox>
                <div class="box-a">
                    <el-checkbox-group
                        v-model="form.coachLessonIds"
                        @change="handleCheckCoachLesson">
                        <el-checkbox
                            style="width:100%; margin: 0px 5px"
                            v-for="item in coachLessons"
                            :label="item.id"
                            :key="item.id"
                        >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer"  style="text-align:center">
            <el-button
                @click="postData"
                type="primary"
            >{{ $t('Message.confirm') }}</el-button>
        </div>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, Row, Col } from 'element-ui';

export default {
    props: ['type'],
    components: {
        ElDialog: Dialog,
        ElRow: Row,
        ElCol: Col,
    },
    data() {
        return {
            id: '',
            staffLesson: {},
            checkAllTeamLesson: false,
            checkAllCoachLesson: false,
            coachLessons: [],
            teamLessons: [],
            teamIndeterminate: false,
            coachIndeterminate: false,
            loading: false,
            visible: false,
            form: {
                coachLessonIds: [],
                teamLessonIds: [],
            },
            rules: {
                content: { required: true, message: this.$t('Fill.message_content'), trigger: 'blur' },
                code: { required: true, message: this.$t('Fill.image_code'), trigger: 'blur' },
            },
        };
    },
    watch: {
    },
    computed: {},
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open(data) {
            if (data) {
                this.id = data.id;
                this.fetchData(data);
            }
        },
        fetchData(data) {
            this.loading = true;
            API.get(`staff/${data.id}/lesson`).then(res => {
                this.staffLesson = res;
                this.form.coachLessonIds = res.coachLessonIds;
                this.form.teamLessonIds = res.teamLessonIds;
                this.visible = true;
                this.fetchTeamLessons();
                this.fetchCoachLessons();
            }).finally(() => {
                this.loading = false;
            }).catch(err => {
                $ele.$message.error(err);
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
            });
        },
        postData() {
            API.put(`staff/${this.id}/lesson`, this.form).then(
                $ele.$message.success(this.$t('Message.send_success')),
                this.visible = false,
            );
        },
        fetchCoachLessons() {
            API.get('lesson/coach/list', {
                params: {
                    active: true,
                },
            }).then(res => {
                this.coachLessons = res;
            });
        },
        fetchTeamLessons() {
            API.get('lesson/team/list', {
                params: {
                    active: true,
                },
            }).then(res => {
                this.teamLessons = res;
            });
        },
        handleCheckAllTeamLesson(val) {
            this.form.teamLessonIds = val ? this.teamLessons.map(el => el.id) : [];
            this.teamIndeterminate = false;
        },
        handleCheckTeamLesson(value) {
            const checkedCount = value.length;
            this.checkAllTeamLesson = checkedCount === this.teamLessons.length;
            this.teamIndeterminate = checkedCount > 0 && checkedCount < this.teamLessons.length;
        },
        handleCheckAllCoachLesson(val) {
            this.form.coachLessonIds = val ? this.coachLessons.map(el => el.id) : [];
            this.coachIndeterminate = false;
        },
        handleCheckCoachLesson(val) {
            const checkedCount = val.length;
            this.checkAllCoachLesson = checkedCount === this.coachLessons.length;
            this.coachIndeterminate = checkedCount > 0 && checkedCount < this.coachLessons.length;
        },
    },
};
</script>

<style lang="scss">
.staff-course-form {
    .el-dialog {
        width: 50%;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-height: 70vh;
        overflow-y: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .el-dialog__body {
        height: 60vh;
        overflow: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .box-a {
        padding: 10px 15px;
        border: 1px solid #e6e6e6;
        background: #fff!important;
        height: 200px!important;
        overflow: scroll;
    }
}
</style>Î
